import axios from "../../../../axios-order";
import { useEffect, useState } from "react"
import { useParams } from 'react-router-dom';
import SaveIcon from '@mui/icons-material/Save';
import LoadingButton from '@mui/lab/LoadingButton';
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { useHistory } from "react-router-dom";
import AnalyticsIcon from '@mui/icons-material/Analytics';
import BarChartIcon from '@mui/icons-material/BarChart';
import { Typography } from '@mui/material';
import Button from '@mui/material/Button';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import GetAppIcon from '@mui/icons-material/GetApp';
import { canRead, canWrite } from "../../../../utils/privilegeUtils";

const GstComputationDetailedReport = () => {
    const { reconId } = useParams();

    let history = useHistory();

    const [data, setData] = useState(null)
    const [formValues, setFormValues] = useState({});
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false)
    const [loadingexcel, setLoadingExcel] = useState(false)
    const [responseMessage, setResponseMessage] = useState("");

    const [confirmButtonloading, setConfirmButtonloading] = useState(false)

    const [isConfirm, setIsConfirm] = useState(localStorage.getItem('is_confirm'))

    const handleChange = (e) => {
        const { name, value } = e.target;
        const [itemName, field] = name.split('.');

        setFormValues(prevValues => ({
            ...prevValues,
            [itemName]: {
                ...prevValues[itemName],
                [field]: value
            }
        }));
    };


    useEffect(() => {
        getGstComputationData()
    }, [])


    const getGstComputationData = () => {

        axios.get(`get_gst_computation_report_data/${reconId}`)
            .then((res) => {
                setData(res.data)

                const initialValues = {};
                if (res.data) {
                    res.data.Inward.Reversal.forEach(item => {
                        initialValues[item.particulars] = {
                            ...item
                        };
                    });
                }
                setFormValues(initialValues);
            })
            .catch((err) => {

            })
    }

    const handleSnackbarOpen = (message, severity) => {
        setSnackbarOpen(true);
        setSnackbarSeverity(severity);
        setResponseMessage(message);


    };

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
        setSnackbarSeverity("success");
        setResponseMessage("");

    };

    const handleSave = () => {
        const payLoadData = {
            'table1_reversal_data': formValues,
            'business_entity_id': localStorage.getItem("business_entity_id"),
            'summary_id': reconId
        }
        setLoading(true)
        axios.post('/save_computation_table1', payLoadData)
            .then(response => {
                handleSnackbarOpen(response?.data?.message, 'success')
                setLoading(false)
                localStorage.setItem('is_confirm', response?.data?.is_confirm)
                setIsConfirm(response?.data?.is_confirm)
            })
            .catch(error => {
                handleSnackbarOpen(error?.data?.message, 'error')
                setLoading(false)
            });
    }

    const handleConfirm = () => {
        const payLoadData = {
            'business_entity_id': localStorage.getItem("business_entity_id"),
            'summary_id': reconId
        }
        setConfirmButtonloading(true)
        axios.post('/generate_computation_table2', payLoadData)
            .then(response => {
                handleSnackbarOpen(response?.data?.message, 'success')
                setConfirmButtonloading(false)
                setIsConfirm(response?.data?.is_confirm)
            })
            .catch(error => {
                handleSnackbarOpen(error?.data?.message, 'error')
                setConfirmButtonloading(false)
            });
    }

    const downloadBase64File = (contentType, base64Data, fileName) => {
        const linkSource = `data:${contentType};base64,${base64Data}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    };


    const handleExportExcel = () => {
        setLoadingExcel(true)
        const payLoadData = {
            summary_id: reconId,
            business_entity_id: localStorage.getItem("business_entity_id"),
            excel_export: true,
            from_month: data?.Outward?.Export?.[0]?.from_month,
            to_month: data?.Outward?.Export?.[0]?.to_month,
            financial_year: data?.Outward?.Export?.[0]?.financial_year,

        }
        const contentType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const filename = `GST Computation Report.xlsx`;

        axios.post('/computation_excel_report', payLoadData)
            .then((res) => {
                downloadBase64File(contentType, res?.data?.file, filename);
            }).catch((err) => {

            })
            .finally(() => {
                setLoadingExcel(false)
            })
    }

    const numberFormat = (value) => {

        if (value === "(Blank)" || value === null) {
            return "₹ 0";
        }

        return new Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: "INR",
            maximumSignificantDigits: 10,
        }).format(value);
    };

    const numberFormattaxrate = (value) => {
        if (value === "(Blank)" || value === null || value === "" || isNaN(value)) {
            return "0%";
        }

        return parseFloat(value) + '%';
    };





    return (
        <div className="gst-statement-wrap">
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

                .gst-statement-wrap {
                    --paper: #F8FAFC;
                    --card: #FFFFFF;
                    --ink: #0F172A;
                    --ink-soft: #64748B;
                    --border: #E2E8F0;
                    --rule-gold: #2F5FBD;
                    --primary: #2F5FBD;
                    --primary-hover: #274C99;
                    --primary-soft: #EEF2FF;
                    --outward: #16A34A;
                    --outward-tint: rgba(22, 163, 74, 0.08);
                    --inward: #7C3AED;
                    --inward-tint: rgba(124, 58, 237, 0.08);
                    --paper-alt: #F4F7FD;
                    --danger: #DC2626;
                    font-family: 'Inter', sans-serif;
                    color: var(--ink);
                    background: var(--paper);
                    padding: 18px 22px 26px;
                    border-radius: 12px;
                }

                .gst-masthead {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 24px;
                    padding: 16px 20px;
                    margin-bottom: 16px;
                    background: var(--card);
                    border: 1px solid var(--border);
                    border-radius: 12px;
                    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 4px 10px rgba(15, 23, 42, 0.05);
                    position: relative;
                }
                .gst-masthead-title {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                }
                .gst-masthead-title > svg.gst-analytics-icon {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    width: 38px;
                    height: 38px;
                    padding: 8px;
                    border-radius: 10px;
                    background: var(--primary-soft);
                    border: 1px solid #C7D2FE;
                    box-sizing: border-box;
                }
                .gst-masthead h1 {
                    font-family: 'Inter', sans-serif;
                    font-weight: 700;
                    font-size: 1.25rem;
                    letter-spacing: 0.1px;
                    color: var(--ink);
                    margin: 0;
                }
                .gst-masthead p {
                    margin: 2px 0 0;
                    font-size: 0.8rem;
                    color: var(--ink-soft);
                    font-style: normal;
                    font-family: 'Inter', sans-serif;
                }
                .gst-analytics-icon {
                    color: var(--primary) !important;
                }
                .gst-payability-btn {
                    background: var(--primary) !important;
                    color: #ffffff !important;
                    border-radius: 9px !important;
                    text-transform: none !important;
                    font-family: 'Inter', sans-serif !important;
                    font-weight: 600 !important;
                    box-shadow: none !important;
                    padding: 8px 18px !important;
                    letter-spacing: 0.1px;
                    white-space: nowrap;
                }
                .gst-payability-btn:hover {
                    background: var(--primary-hover) !important;
                    box-shadow: none !important;
                }

                .gst-table-card {
                    border: 1px solid var(--border);
                    border-radius: 14px;
                    background: var(--card);
                    overflow: hidden;
                    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px rgba(15, 23, 42, 0.05);
                }
                .gst-table-shell {
                    min-height: 54vh;
                    background: var(--card);
                    overflow: auto;
                }
                table.gst-table {
                    width: 100%;
                    border-collapse: collapse;
                    font-variant-numeric: tabular-nums;
                }
                .gst-table thead th,
                .gst-table tr.gst-col-head th {
                    position: sticky;
                    top: 0;
                    z-index: 2;
                    background: var(--primary) !important;
                    color: #ffffff !important;
                    font-family: 'Inter', sans-serif;
                    font-weight: 600;
                    font-size: 0.78rem;
                    text-align: right;
                    padding: 11px 12px;
                    border-bottom: none !important;
                }
                .gst-table tr.gst-col-head th:first-child {
                    text-align: left;
                    width: 210%;
                }

                .gst-table td {
                    padding: 8px 12px;
                    text-align: right;
                    font-size: 0.85rem;
                    border-bottom: 1px solid var(--border);
                    color: var(--ink);
                }
                .gst-table td:first-child {
                    text-align: left;
                    color: var(--ink-soft);
                }
                .gst-table tbody tr.gst-data-row:nth-of-type(even) td {
                    background: var(--paper-alt);
                }
                .gst-table tbody tr.gst-data-row:hover td {
                    background: #EAF0FC;
                }

                .gst-group-row td {
                    font-family: 'Inter', sans-serif;
                    font-weight: 700;
                    font-size: 0.92rem;
                    padding: 12px 12px 6px;
                    border-bottom: 1px solid var(--primary);
                    color: var(--ink);
                }

                .gst-section-row td {
                    text-align: left;
                    font-family: 'Inter', sans-serif;
                    font-weight: 600;
                    font-size: 0.76rem;
                    letter-spacing: 0.2px;
                    padding: 7px 12px 7px 14px;
                    border-bottom: none;
                    border-top: none;
                }
                .gst-section-row.outward td {
                    color: var(--outward);
                    background: var(--outward-tint);
                    border-left: 3px solid var(--outward);
                }
                .gst-section-row.inward td {
                    color: var(--inward);
                    background: var(--inward-tint);
                    border-left: 3px solid var(--inward);
                }

                .gst-total-row td {
                    font-weight: 700;
                    color: var(--ink);
                    border-top: 2px solid var(--ink);
                    border-bottom: 2px solid var(--ink);
                    background: var(--paper-alt);
                }

                .gst-field {
                    width: 82%;
                    background: var(--card);
                    border: 1px solid var(--border);
                    border-radius: 6px;
                    text-align: right;
                    font-family: 'Inter', sans-serif;
                    font-weight: 500;
                    font-variant-numeric: tabular-nums;
                    color: var(--ink);
                    padding: 5px 8px;
                    outline: none;
                    transition: border-color 0.15s ease, box-shadow 0.15s ease;
                }
                .gst-field:hover {
                    border-color: #C7D2FE;
                }
                .gst-field:focus {
                    border-color: var(--primary);
                    box-shadow: 0 0 0 3px var(--primary-soft);
                }
                .gst-field-readonly {
                    display: inline-block;
                    width: 82%;
                    text-align: right;
                    color: var(--ink-soft);
                }

                .gst-actions {
                    display: flex;
                    justify-content: flex-end;
                    gap: 10px;
                    margin-top: 14px;
                }
                .gst-btn-confirm {
                    border-radius: 9px !important;
                    text-transform: none !important;
                    font-family: 'Inter', sans-serif !important;
                    font-weight: 600 !important;
                    background: #FEF2F2 !important;
                    color: var(--danger) !important;
                    border: 1px solid #FECACA !important;
                    box-shadow: none !important;
                    min-width: 130px !important;
                }
                .gst-btn-confirm:hover {
                    background: var(--danger) !important;
                    color: #ffffff !important;
                    border-color: var(--danger) !important;
                }
                .gst-btn-save {
                    border-radius: 9px !important;
                    text-transform: none !important;
                    font-family: 'Inter', sans-serif !important;
                    font-weight: 600 !important;
                    background: var(--primary) !important;
                    color: #ffffff !important;
                    box-shadow: none !important;
                    min-width: 130px !important;
                }
                .gst-btn-save:hover {
                    background: var(--primary-hover) !important;
                    box-shadow: none !important;
                }

                .gst-masthead-actions {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    flex-shrink: 0;
                }
                .gst-back-btn,
                .gst-export-btn {
                    background: var(--card) !important;
                    color: var(--ink-soft) !important;
                    border: 1px solid var(--border) !important;
                    border-radius: 9px !important;
                    text-transform: none !important;
                    font-family: 'Inter', sans-serif !important;
                    font-weight: 600 !important;
                    box-shadow: none !important;
                    padding: 8px 16px !important;
                    letter-spacing: 0.1px;
                    white-space: nowrap;
                }
                .gst-back-btn:hover,
                .gst-export-btn:hover {
                    background: var(--paper-alt) !important;
                    color: var(--ink) !important;
                    border-color: var(--borderStrong, #CBD5E1) !important;
                }

            `}</style>

            <div className="gst-masthead">
                <div className="gst-masthead-title">
                    <AnalyticsIcon className="gst-analytics-icon" />
                    <div>
                        <h1>GST Computation Statement</h1>
                        <p>Outward &amp; inward supply ledger for this filing period</p>
                    </div>
                </div>

                <div className="gst-masthead-actions">
                    <Button
                        variant="outlined"
                        className="gst-back-btn"
                        onClick={() => history.goBack()}
                        startIcon={<ArrowBackIcon />}
                    >
                        Back
                    </Button>

                    <LoadingButton
                        variant="outlined"
                        className="gst-export-btn"
                        onClick={handleExportExcel}
                        loading={loadingexcel}
                        loadingPosition="start"
                        startIcon={<GetAppIcon />}
                    >
                        <span>Export</span>
                    </LoadingButton>

                    <Button
                        variant="contained"
                        className="gst-payability-btn"
                        onClick={() => history.push(`/gst_computation_paybality_report_data/${reconId}`)}
                        endIcon={<BarChartIcon />}
                    >
                        GST Payability
                    </Button>
                </div>
            </div>

            <div className="gst-table-card">
                <div className="responsive-table gst-table-shell">
                    <table className="custome-table gst-table">
                        <tbody>
                            <tr className="gst-col-head">
                                <th>Particulars</th>
                                <th>Tax Rate</th>
                                <th>Taxable Value</th>
                                <th>IGST</th>
                                <th>CGST</th>
                                <th>SGST</th>
                                <th>CESS</th>
                                <th>Total GST</th>
                                <th>Invoice Value</th>
                            </tr>

                            <tr className="gst-group-row">
                                <td colSpan={9}>
                                    (A) Outward Supplies
                                </td>
                            </tr>

                            {/* Render Export Section */}
                            <tr className="gst-section-row outward">
                                <td colSpan={9}>
                                    Export
                                </td>
                            </tr>
                            {data?.Outward?.Export?.map((item, index) => (
                                <tr className="gst-data-row" key={index}>
                                    <td>{item.particulars}</td>
                                    <td>{item.particulars === "Total Export" ? ' ' : numberFormattaxrate(item.tax_rate)}</td>
                                    <td>{numberFormat(item.taxable_value)}</td>
                                    <td>{numberFormat(item.igst)}</td>
                                    <td>{numberFormat(item.cgst)}</td>
                                    <td>{numberFormat(item.sgst)}</td>
                                    <td>{numberFormat(item.cess)}</td>
                                    <td>{numberFormat(item.total_gst)}</td>
                                    <td>{numberFormat(item.invoice_value)}</td>
                                </tr>
                            ))}

                            {/* Render Intra State Sales Section */}
                            <tr className="gst-section-row outward">
                                <td colSpan={9}>
                                    Intra State
                                </td>
                            </tr>
                            {data && data?.Outward['Intra State']?.map((item, index) => (
                                <tr className="gst-data-row" key={index}>
                                    <td>{item.particulars}</td>
                                    <td>{item.particulars === "Total Intra State" ? ' ' : numberFormattaxrate(item.tax_rate)}</td>
                                    <td>{numberFormat(item.taxable_value)}</td>
                                    <td>{numberFormat(item.igst)}</td>
                                    <td>{numberFormat(item.cgst)}</td>
                                    <td>{numberFormat(item.sgst)}</td>
                                    <td>{numberFormat(item.cess)}</td>
                                    <td>{numberFormat(item.total_gst)}</td>
                                    <td>{numberFormat(item.invoice_value)}</td>
                                </tr>
                            ))}

                            {/* Render Inter State Sales Section */}
                            <tr className="gst-section-row outward">
                                <td colSpan={9}>
                                    Inter State
                                </td>
                            </tr>
                            {data && data?.Outward['Inter State']?.map((item, index) => (
                                <tr className="gst-data-row" key={index}>
                                    <td>{item.particulars}</td>
                                    <td>{item.particulars === "Total Inter State" ? ' ' : numberFormattaxrate(item.tax_rate)}</td>
                                    <td>{numberFormat(item.taxable_value)}</td>
                                    <td>{numberFormat(item.igst)}</td>
                                    <td>{numberFormat(item.cgst)}</td>
                                    <td>{numberFormat(item.sgst)}</td>
                                    <td>{numberFormat(item.cess)}</td>
                                    <td>{numberFormat(item.total_gst)}</td>
                                    <td>{numberFormat(item.invoice_value)}</td>
                                </tr>
                            ))}

                            {/* Render B2C   Section */}
                            <tr className="gst-section-row outward">
                                <td colSpan={9}>
                                    B2CS
                                </td>
                            </tr>
                            {data && data?.Outward?.B2CS?.map((item, index) => (
                                <tr className="gst-data-row" key={index}>
                                    <td>{item.particulars}</td>
                                    <td>{numberFormattaxrate(item.tax_rate)}</td>
                                    <td>{numberFormat(item.taxable_value)}</td>
                                    <td>{numberFormat(item.igst)}</td>
                                    <td>{numberFormat(item.cgst)}</td>
                                    <td>{numberFormat(item.sgst)}</td>
                                    <td>{numberFormat(item.cess)}</td>
                                    <td>{numberFormat(item.total_gst)}</td>
                                    <td>{numberFormat(item.invoice_value)}</td>
                                </tr>
                            ))}

                            {/* Render Missing in accounts   Section */}
                            <tr className="gst-section-row outward">
                                <td colSpan={9}>
                                    Missing in account
                                </td>
                            </tr>
                            {data && data?.Outward['Missing in account']?.map((item, index) => (
                                <tr className="gst-data-row" key={index}>
                                    <td>{item.particulars}</td>
                                    <td>{numberFormattaxrate(item.tax_rate)}</td>
                                    <td>{numberFormat(item.taxable_value)}</td>
                                    <td>{numberFormat(item.igst)}</td>
                                    <td>{numberFormat(item.cgst)}</td>
                                    <td>{numberFormat(item.sgst)}</td>
                                    <td>{numberFormat(item.cess)}</td>
                                    <td>{numberFormat(item.total_gst)}</td>
                                    <td>{numberFormat(item.invoice_value)}</td>
                                </tr>
                            ))}

                            <tr className="gst-section-row outward">
                                <td colSpan={9}>
                                    Total (A)
                                </td>
                            </tr>
                            {data && data?.Outward['Total (A)']?.map((item, index) => (
                                <tr className="gst-total-row" key={index}>
                                    <td>{item.particulars}</td>
                                    <td>{numberFormattaxrate(item.tax_rate)}</td>
                                    <td>{numberFormat(item.taxable_value)}</td>
                                    <td>{numberFormat(item.igst)}</td>
                                    <td>{numberFormat(item.cgst)}</td>
                                    <td>{numberFormat(item.sgst)}</td>
                                    <td>{numberFormat(item.cess)}</td>
                                    <td>{numberFormat(item.total_gst)}</td>
                                    <td>{numberFormat(item.invoice_value)}</td>
                                </tr>
                            ))}

                            <tr className="gst-group-row">
                                <td colSpan={9}>
                                    (B) Inward Supplies
                                </td>
                            </tr>

                            {data && data?.Inward?.without_rcm?.map((item, index) => (
                                <tr className="gst-data-row" key={index}>
                                    <td>{item.particulars}</td>
                                    <td>{item.particulars === "Total Purchases" ? ' ' : numberFormattaxrate(item.tax_rate)}</td>
                                    <td>{numberFormat(item.taxable_value)}</td>
                                    <td>{numberFormat(item.igst)}</td>
                                    <td>{numberFormat(item.cgst)}</td>
                                    <td>{numberFormat(item.sgst)}</td>
                                    <td>{numberFormat(item.cess)}</td>
                                    <td>{numberFormat(item.total_gst)}</td>
                                    <td>{numberFormat(item.invoice_value)}</td>
                                </tr>
                            ))}

                            {/* Render rcm   Section */}
                            <tr className="gst-section-row inward">
                                <td colSpan={9}>
                                    RCM
                                </td>
                            </tr>
                            {data && data?.Inward?.rcm?.map((item, index) => (
                                <tr className="gst-data-row" key={index}>
                                    <td>{item.particulars}</td>
                                    <td>{item.particulars === "Total rcm" ? ' ' : numberFormattaxrate(item.tax_rate)}</td>
                                    <td>{numberFormat(item.taxable_value)}</td>
                                    <td>{numberFormat(item.igst)}</td>
                                    <td>{numberFormat(item.cgst)}</td>
                                    <td>{numberFormat(item.sgst)}</td>
                                    <td>{numberFormat(item.cess)}</td>
                                    <td>{numberFormat(item.total_gst)}</td>
                                    <td>{numberFormat(item.invoice_value)}</td>
                                </tr>
                            ))}

                            {/* Render reversal   Section */}
                            <tr className="gst-section-row inward">
                                <td colSpan={9}>
                                    Reversal
                                </td>
                            </tr>
                            {data && data?.Inward?.Reversal?.map((item, index) => (
                                <tr className="gst-data-row" key={index}>
                                    <td>{item.particulars}</td>
                                    <td>
                                        {canWrite("GST COMPUTATION REPORT") ? <input
                                            type="number"
                                            className='gst-field'
                                            name={`${item.particulars}.tax_rate`}
                                            value={formValues[item.particulars]?.tax_rate || ''}
                                            onChange={handleChange}
                                        /> : <span className="gst-field-readonly">{formValues[item.particulars]?.tax_rate || ''}</span>}
                                    </td>
                                    <td>
                                        {canWrite("GST COMPUTATION REPORT") ? <input
                                            type="number"
                                            className='gst-field'
                                            name={`${item.particulars}.taxable_value`}
                                            value={formValues[item.particulars]?.taxable_value || ''}
                                            onChange={handleChange}
                                        /> : <span className="gst-field-readonly">{formValues[item.particulars]?.taxable_value || ''}</span>}
                                    </td>
                                    <td>
                                        {canWrite("GST COMPUTATION REPORT") ? <input
                                            type="number"
                                            className='gst-field'
                                            name={`${item.particulars}.igst`}
                                            value={formValues[item.particulars]?.igst || ''}
                                            onChange={handleChange}
                                        /> : <span className="gst-field-readonly">{formValues[item.particulars]?.igst || ''}</span>}
                                    </td>
                                    <td>
                                        {canWrite("GST COMPUTATION REPORT") ? <input
                                            type="number"
                                            className='gst-field'
                                            name={`${item.particulars}.cgst`}
                                            value={formValues[item.particulars]?.cgst || ''}
                                            onChange={handleChange}
                                        /> : <span className="gst-field-readonly">{formValues[item.particulars]?.cgst || ''}</span>}
                                    </td>
                                    <td>
                                        {canWrite("GST COMPUTATION REPORT") ? <input
                                            type="number"
                                            className='gst-field'
                                            name={`${item.particulars}.sgst`}
                                            value={formValues[item.particulars]?.sgst || ''}
                                            onChange={handleChange}
                                        /> : <span className="gst-field-readonly">{formValues[item.particulars]?.sgst || ''}</span>}
                                    </td>
                                    <td>
                                        {canWrite("GST COMPUTATION REPORT") ? <input
                                            type="number"
                                            className='gst-field'
                                            name={`${item.particulars}.cess`}
                                            value={formValues[item.particulars]?.cess || ''}
                                            onChange={handleChange}
                                        /> : <span className="gst-field-readonly">{formValues[item.particulars]?.cess || ''}</span>}
                                    </td>
                                    <td>
                                        {canWrite("GST COMPUTATION REPORT") ? <input
                                            type="number"
                                            className='gst-field'
                                            name={`${item.particulars}.total_gst`}
                                            value={formValues[item.particulars]?.total_gst || ''}
                                            onChange={handleChange}
                                        /> : <span className="gst-field-readonly">{formValues[item.particulars]?.total_gst || ''}</span>}
                                    </td>
                                    <td>
                                        {canWrite("GST COMPUTATION REPORT") ? <input
                                            type="number"
                                            className='gst-field'
                                            name={`${item.particulars}.invoice_value`}
                                            value={formValues[item.particulars]?.invoice_value || ''}
                                            onChange={handleChange}
                                        /> : <span className="gst-field-readonly">{formValues[item.particulars]?.invoice_value || ''}</span>}
                                    </td>
                                </tr>
                            ))}



                        </tbody>
                    </table>
                </div>
            </div>
            <div className="gst-actions">
                {canWrite("GST COMPUTATION REPORT") && isConfirm === "Y" && <LoadingButton
                    className="gst-btn-confirm"
                    onClick={handleConfirm}
                    loading={confirmButtonloading}
                    loadingPosition="start"
                    startIcon={<ErrorOutlineIcon />}
                    variant="contained"
                >
                    <span>Confirm</span>
                </LoadingButton>}

                {canWrite("GST COMPUTATION REPORT") && <LoadingButton
                    className="gst-btn-save"
                    onClick={handleSave}
                    loading={loading}
                    loadingPosition="start"
                    startIcon={<SaveIcon />}
                    variant="contained"
                >
                    <span>Save</span>
                </LoadingButton>}
            </div>
            <Snackbar
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                open={snackbarOpen}
                autoHideDuration={5000}
                onClose={handleSnackbarClose}
                style={{ maxWidth: '25%' }}
            >
                <MuiAlert
                    elevation={6}
                    variant="filled"
                    onClose={handleSnackbarClose}
                    severity={snackbarSeverity}
                    style={{
                        fontFamily: "'Inter', sans-serif",
                        backgroundColor: snackbarSeverity === 'success' ? '#16A34A' : '#DC2626',
                        borderRadius: '9px'
                    }}
                >
                    {responseMessage}
                    {message}
                </MuiAlert>
            </Snackbar>
        </div>
    )
}

export default GstComputationDetailedReport